module.exports = __webpack_public_path__ + "img/profile.42b88a7e.svg";